module.exports = __webpack_public_path__ + "two_col.png?bdc94d10d5a2657c22357bb34ece1f4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/two_col.png
// module id = 566
// module chunks = 0